export const cacheKeys = {
  getAppointmentTypes: (params) =>
    params ? ['getAppointmentTypes', params] : ['getAppointmentTypes'],
  getTopics: (params) =>
    params ? ['getTopics', params] : ['getTopics'],
};
